import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { AddToPlaylistComponent } from "../add-to-playlist/add-to-playlist.component";
import { MatDialog } from "@angular/material/dialog";
import { ToastrService } from "ngx-toastr";
import Swal from "sweetalert2";
@Component({
  selector: "app-music",
  templateUrl: "./music.component.html",
  styleUrls: ["./music.component.css"],
})
export class MusicComponent implements OnInit {
  shimmerStatus = {
    category: true,
    topSongs: true,
    favoriteSongs: false,
    playList: false,
  };
  data: any;
  apiParam = {
    slug: "",
    type: "",
    limit: 20,
    offset: 0,
    feature: true,
    banner: true,
  };
  params = {
    limit: 10,
    offset: 0,
  };
  categoryParam = {
    slug: "",
    limit: 10,
    offset: 0,
    feature: false,
    banner: false,
    type: "",
  };
  subcategory = [];
  investiLanguage: any;
  loadMore = false;
  initStatus: boolean;
  viewMore = true;
  show = true;
  homeData;
  songData = [];
  favoriteSongs: any = [];
  playListData: any = [];
  appConstant: any;
  subCategoryCount: any;
  @ViewChild("panel", { read: ElementRef }) public panel: ElementRef<any>;
  featuredData: any = [];
  isLoding = true;
  categoryData: any = [];
  categoryContent: any = [];
  isContent = true;
  constructor(
    public service: BaseService,
    private router: Router,
    public translate: TranslateService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.appConstant = environment;
    window.scrollTo(0, 0);
    if (localStorage.getItem(environment.localStorageLangKey)) {
      this.investiLanguage = JSON.parse(
        localStorage.getItem(environment.localStorageLangKey)
      );
      this.translate.use(this.investiLanguage);
    }

    this.initStatus = true;
    if (this.router.url) {
      let url = this.router.url.split("/");
      this.apiParam.type = url[1];
      this.categoryParam.type = url[1];
      this.service.playerReady = false;
      this.service.modelData = undefined;
    } else {
      this.service.playerReady = false;
      this.service.modelData = undefined;
    }
    this.route.paramMap.subscribe((params: any) => {
      if (params.params["slug"]) {
        this.apiParam.slug = params.params["slug"];
      }
    });
    if (localStorage.getItem(environment.localStorageKey)) {
      this.shimmerStatus.favoriteSongs = true;
      this.shimmerStatus.playList = true;
      this.getFavoriteSongs();
      this.getPlayList();
    }
    this.moreData("");
    this.getTopSongs();
    this.categoryList();
  }

  topalbum: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: [
      '<i class="mdi mdi-arrow-left"></i>',
      '<i class="mdi mdi-arrow-right"></i>',
    ],
    responsive: {
      0: {
        items: 3.2,
      },
      380: {
        items: 3.6,
      },
      450: {
        items: 3.7,
      },
      650: {
        items: 4.5,
      },
      768: {
        items: 6,
      },
      991: {
        items: 7,
      },
      1230: {
        items: 8,
      },
      1366: {
        items: 9,
      },
      1900: {
        items: 11,
      },
    },
    nav: true,
  };

  categoryList() {
    this.service.categoryList(this.apiParam).subscribe((res: any) => {
      this.categoryData = res.results;
      if (this.categoryData.length > 0) {
        this.categoryParam.slug = this?.categoryData[0]?.slug;
        this.categoryData[0].checked = true;
        this.subCategoryCount = this.categoryData[0].subcategoryCount;
        this.categoryContentData();
      }
    });
  }
  selectCategory(data: any) {
    this.isContent = true;
    this.categoryParam.slug = data.slug;
    this.subCategoryCount = data.subcategoryCount;
    this.categoryData.map((el) => {
      if (el.public_id == data.public_id) {
        el.checked = true;
      } else {
        el.checked = false;
      }
    });
    this.categoryContentData();
  }
  categoryContentData() {
    this.service.categoryData(this.categoryParam).subscribe((res) => {
      this.categoryContent = res.content;
      this.categoryContent.map((data) => {
        let item = data.thumbnails.findIndex(
          (el) => el.image_type === "square"
        );
        if (item != -1) {
          data.thumbnail = data.thumbnails[item].asset;
        } else {
          data.thumbnail = this.appConstant.squareDefault;
        }
      });
      this.isContent = false;
    });
  }
  addToPlayList(data: any) {
    const dialogRef = this.dialog.open(AddToPlaylistComponent, {
      panelClass: "song-dialog",
      data: "create",
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.getPlayList();
    });
  }
  playOff() {
    this.service.modelData = undefined;
    this.service.playerReady = false;
  }
  moreData(from) {
    if (this.initStatus) {
      this.service.categoryData(this.apiParam).subscribe(
        (data: any) => {
          this.data = data;
          if (from === "") {
            this.subcategory = [];
          }
          if (this.data.subcategory.length > 0) {
            this.subcategory = this.subcategory.concat(this.data.subcategory);
            this.loadMore = false;
            this.show = true;
            this.shimmerStatus.category = false;
          } else {
            this.shimmerStatus.category = false;
            this.loadMore = false;
            this.show = false;
          }
        },
        (err) => {
          if (err) {
            setTimeout(() => {
              this.shimmerStatus.category = false;
              this.loadMore = false;
            }, 3000);
          }
        }
      );
    }
  }
  getTopSongs() {
    this.service.topSongsList(this.params).subscribe(
      (res) => {
        this.songData = res.results;
        this.shimmerStatus.topSongs = false;
      },
      (err: any) => {
        this.shimmerStatus.topSongs = false;
      }
    );
  }
  getFavoriteSongs() {
    const data = {
      limit: 10,
      offset: 0,
      type: "album",
    };
    this.service.favoriteList(data).subscribe(
      (res) => {
        res.results.map((el) => {
          this.favoriteSongs = this.favoriteSongs.concat(el.content);
        });
        this.shimmerStatus.favoriteSongs = false;
      },
      (err: any) => {
        this.shimmerStatus.favoriteSongs = false;
      }
    );
  }

  getPlayList() {
    const data = {
      limit: 10,
      offset: 0,
      type: "album",
    };
    this.service.playList(data).subscribe(
      (res) => {
        this.playListData = res.results;
        this.shimmerStatus.playList = false;
      },
      (err: any) => {
        this.shimmerStatus.playList = false;
      }
    );
  }
  viewMoreData() {
    this.loadMore = true;
    this.show = false;
    if (this.data.subcategory.length > 0 && this.loadMore === true) {
      this.apiParam.offset = this.apiParam.limit + this.apiParam.offset;
      this.moreData("pagination");
    }
  }

  deletePlayList(data: any, ind: any) {
    Swal.fire({
      title: "Are you sure",
      text: "You want to remove this?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, remove it!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.service.deletePlayList(data).subscribe(
          (res) => {
            this.playListData.splice(ind, 1);
            this.toastr.success(res.message, "Success!", {
              closeButton: true,
            });
          },
          (err: any) => {
            this.toastr.error(err.error.message, "OOPS!", {
              closeButton: true,
            });
          }
        );
      }
    });
  }
  ngOnDestroy() {
    this.dialog.closeAll();
    Swal.close();
  }
}
